import { olivePalette } from './olive'
import { sagePalette } from './sage'
import { lightingPalette } from './lighting'

export const palettes = {
  sage: sagePalette,
  olive: olivePalette,
  lighting: lightingPalette
}

export type ThemeName = keyof typeof palettes
